import { render, staticRenderFns } from "./Counselor.vue?vue&type=template&id=4a706574&"
import script from "./Counselor.vue?vue&type=script&lang=js&"
export * from "./Counselor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports